import { useMutation } from '@tanstack/react-query';
import { sendData } from '../fetchers';

export const useAuthMutation = () =>
  useMutation({
    mutationFn: ({ data, params, queryParams }) =>
      sendData('auth/login', data, params, queryParams),
  });

export const useLogoutMutation = () =>
  useMutation({ mutationFn: (data) => sendData('auth/logout', data) });
